import { deleteScopedKey, readWaterJSON, writeWaterJSON } from './waterStorage'

const KEY = 'productionUnitCustomColumns'

export const loadProductionUnitCustomColumns = <T = Record<string, unknown>>(): T =>
  readWaterJSON<T>(KEY, {} as T)

export const saveProductionUnitCustomColumns = <T>(value: T): void => {
  writeWaterJSON(KEY, value)
}

export const deleteProductionUnitCustomColumns = (): void => {
  deleteScopedKey(KEY)
}
